import Iridescence from "@/Iridescence.jsx";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react";

export default function Test() {
  // Subtitle refs
  const subtitleRefs = useRef<HTMLSpanElement[]>([]);
  // Title refs
  const titleRefs = useRef<HTMLSpanElement[]>([]);
  const titleBoldRefs = useRef<HTMLSpanElement[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);
  const n2aiRef = useRef<HTMLImageElement>(null);

  useGSAP(
    () => {
      const subtitleSpans = subtitleRefs.current;
      const titleSpans = titleRefs.current;
      const titleBoldSpans = titleBoldRefs.current;

      const tl = gsap.timeline({ delay: 0.8 });

      // Subtitle 애니메이션
      if (subtitleSpans.length) {
        tl.from(
          subtitleSpans,
          {
            opacity: 0,
            y: 30,
            filter: "blur(15px)",
            stagger: 0.035,
            duration: 0.5,
            ease: "power4.out",
          },
          "-=0.1"
        );
      }

      // Title 애니메이션
      if (titleSpans.length) {
        tl.from(
          titleSpans,
          {
            opacity: 0,
            y: 50,
            rotateX: -90,
            filter: "blur(20px)",
            stagger: 0.03,
            duration: 0.4,
            ease: "power4.out",
          },
          "-=0.3"
        );
      }

      // Bold Title 애니메이션
      if (titleBoldSpans.length) {
        tl.from(
          titleBoldSpans,
          {
            opacity: 0,
            y: 50,
            rotateX: -90,
            filter: "blur(20px)",
            stagger: 0.03,
            duration: 0.4,
            ease: "power4.out",
          },
          "-=0.5"
        );
      }

      // N2AI 이미지 Fade In 애니메이션
      if (n2aiRef.current) {
        gsap.set(n2aiRef.current, { opacity: 0, y: 30 });
        tl.to(
          n2aiRef.current,
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.8,
            ease: "power4.out",
          },
          "-=0.3"
        );
      }
    },
    { scope: containerRef, revertOnUpdate: true, dependencies: [] }
  );

  return (
    <div className="fixed inset-0" ref={containerRef}>
      {/* <Aurora
        colorStops={["#86C7F1", "#0000FF", "#EB2599"]}
        blend={0.5}
        amplitude={1.0}
        speed={1}
      /> */}
      <Iridescence
        color={[0.4, 0, 0.9]}
        mouseReact={true}
        amplitude={0.05}
        // speed={1}
      />
      <div className="fixed inset-0 pointer-events-none">
        <div className="flex items-center justify-center h-full flex-col gap-5 ">
          <p className="text-white text-[20px]">
            {"AI로 연결되는 더 안전한 병원 운영·관리".split("").map((e, i) => (
              <span
                key={`subtitle:${i}`}
                ref={(el) => {
                  if (el) {
                    subtitleRefs.current[i] = el;
                  }
                }}
                className="relative inline-block"
              >
                {e === " " ? "\u00A0" : e}
              </span>
            ))}
          </p>
          <h1 className="text-white text-6xl font-pretendard">
            {"Healthcare ".split("").map((e, i) => (
              <span
                key={`title:${i}`}
                ref={(el) => {
                  if (el) {
                    titleRefs.current[i] = el;
                  }
                }}
                className="relative inline-block"
              >
                {e === " " ? "\u00A0" : e}
              </span>
            ))}
            <span className="font-bold">
              {"Safety ERP".split("").map((e, i) => (
                <span
                  key={`titleBold:${i}`}
                  ref={(el) => {
                    if (el) {
                      titleBoldRefs.current[i] = el;
                    }
                  }}
                  className="relative inline-block"
                >
                  {e === " " ? "\u00A0" : e}
                </span>
              ))}
            </span>
          </h1>
          {/* <div className="absolute bottom-30">
            <img ref={n2aiRef} src="/img/n2ai.png" alt="n2ai" className="" />
          </div> */}
        </div>
      </div>
    </div>
  );
}
